export default {
  objectSelected: (state) => state.objectSelected,
  objectDetailsSelected: (state) => state.objectDetailsSelected,
  objectDetailsInfo: (state) => state.objectDetailsInfo,
  objectZoneGroupMode: (state) => state.objectZoneGroupMode,
  objectsPeriod: (state, getters) => (state.objectZoneGroupMode ? getters.zoneGroupPeriods : state.objectsPeriod),
  objectLayers: (state) => state.objectLayers,

  /**
   * Слои (Полная информация)
   * @param {*} state
   * @returns
   */
  objectLayerSettings: (state) => state.objectLayerSettings,
  objectLayerItems: (state) => state.objectLayerItems,
  objectMapData: (state) => state.objectMapData,
  object3DMapData: (state) => state.object3DMapData,
  objectContainerTypes: (state) => state.objectContainerTypes,
  territoryColors: (state) => state.territoryColors,
  forceClosePanels: (state) => state.forceClosePanels,
  forceDefaultVisibilityPanels: (state) => state.forceDefaultVisibilityPanels,
  objectMapParams: (state) => state.objectMapParams,
  objectExactMapParams: (state) => state.objectExactMapParams,
  objectMapRequestTime: (state) => state.objectMapRequestTime,
  objectMapCacheUpdated: (state) => state.objectMapCacheUpdated,
  objectLayerTypes: (state) => state.objectLayerTypes,
  objectStaticInfo: (state) => state.objectStaticInfo,
  objectShowContainerRoute: (state) => state.objectShowContainerRoute,
  forceObjectMapCenter: (state) => state.forceObjectMapCenter,
  forceObjectMapBounds: (state) => state.forceObjectMapBounds,
  objectLoadingData: (state) => state.objectLoadingData,
  objectWastes: (state) => state.objectWastes,
  objectWasteSelected: (state) => state.objectWasteSelected,

  /**
   * Список фильтров в виде массива
   * @param {*} state
   * @returns
   */
  objectFilterList: (state) => state.objectFilterList,

  /**
   * Словарь фильтров по идентификатору
   * @param {*} state
   */
  objectFilterById: (state) => {
    return state.objectFilterList.reduce((result, filter) => {
      result[filter.id] = filter
      return result
    }, {})
  },

  /**Список сохраненных фильтров ws */
  objectFilters: (state) => state.objectFilters,

  /**Справочник полей по которым можно фильтровать */
  objectfilterDict: (state) => state.objectfilterDict,

  objectTreatmentSelected: (state) => state.objectTreatmentSelected,
  objectLayerNames: (state) => state.objectLayerNames,
  objectVisibilityProperty: (state) => (state.objectZoneGroupMode ? 'zoneVisibility' : 'visibility'),
  objectDefaultVisibilityProperty: (state) => (state.objectZoneGroupMode ? 'defaultZoneModeVisibility' : 'defaultVisibility'),
  objectInitialVisibilityProperty: (state) => (state.objectZoneGroupMode ? 'initialZoneModeVisibility' : 'initialVisibility'),
  objectPublicFilters: (state, getters) => {
    return getters.workspace && state.objectPublicFilters && state.objectPublicFilters[getters.workspace + '']
      ? state.objectPublicFilters[getters.workspace + '']
      : null
  },
  objectFilterRequestParams: (state, getters) => {
    const requestParams = {}
    if (state.objectFilters.map) {
      requestParams.square = state.objectExactMapParams.square
    }
    if (state.objectFilters.text) {
      requestParams.text = state.objectFilters.text
    }
    if (getters.objectPublicFilters && getters.objectPublicFilters.length > 0) {
      requestParams.active_filters = getters.objectPublicFilters.join(',')
    }
    return requestParams
  },
  objectVisibilityByTypeAndId: (state, getters) => {
    return (params) => {
      params.type = params.type === 'adm_territory' || params.type === 'dedicated_territory' ? 'zonegroup' : params.type
      if (params.type && params.id) {
        if (params.subtype && params.type !== 'info' && params.type !== 'streaminfo') {
          params.id = params.subtype + '-' + params.id
        }

        let layersInfo = getters.objectLayerItems
        let layerSettings = getters.objectLayerSettings

        if (params.type === 'info' || params.type === 'streaminfo') {
          const layerId = `${params.type}-${params.subtype}`
          const objectId = params.id
          const layerObjects = (getters.layerObjects[layerId] || {}).objects || {}
          const leftPanelLayerObject = layerObjects[objectId]

          return leftPanelLayerObject ? leftPanelLayerObject.visibility : getters.getLayerVisibility(layerId)
        }

        if (
          ['emitter', 'infrastructure', 'zonegroup', 'building', 'transportbase', 'collectingloop', 'transfer', 'removaltrip', 'flow', 'source'].indexOf(
            params.type
          ) > -1
        ) {
          return layersInfo[params.type].objectsInfo[params.id] && layerSettings[params.type].canToggleItemsVisibility
            ? layersInfo[params.type].objectsInfo[params.id].visibility
            : layerSettings[params.type].visibility
        }
        if (['containerplatform'].indexOf(params.type) > -1) {
          return layersInfo[params.type].childrenInfo[params.id]
            ? layersInfo[params.type].childrenInfo[params.id].visibility
            : layerSettings[params.type].visibility
        }
      }
      return true
    }
  },

  fieldsControlDict: (state) => {
    return state.fieldsControlDict || null
  }
}



// WEBPACK FOOTER //
// ./src/store/objects/getters.js